<!--
  2021-06-27 C007 Add showFooter property
-->
<template>
  <div id="app">
    <TopBar v-if="$route.meta.showTopBar"/>
    <LoginPop v-if="$store.state.loginPopShow" />
    <div id="viewContainer">
      <transition name="slide" mode="out-in">
        <keep-alive v-if="$route.meta.keepAlive" key="keepAlive">
          <router-view/>
        </keep-alive>
        <router-view v-else key="refresh"/>
      </transition>
    </div>
    <FooterGuide v-if="$route.meta.showFooter"/>
  </div>
</template>

<script>
import TopBar from './components/TopBar/index'
import FooterGuide from './components/FooterGuide/index'
import LoginPop from './components/LoginPop/index'
export default {
  name: 'App',
  components: {FooterGuide, TopBar, LoginPop},
  mounted () {
  }
}
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
input {
  background: none;
  outline:none;
  border: none;
}
.bigSizeToastMessage span {
  font-size: 1.3em !important;
}
#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  overflow: hidden;
  color: #686868;
  display: flex;
  flex-direction: column;
  background-color: #161616;

  #viewContainer {
    flex: 1;
    padding-bottom: 48px;
    position: absolute;
    width: 100%;
    height: 100%;
    background: #161616;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue